import "./GlPeriodBalance.scss";
import newRequest from "../../../utils/newRequest.js";
import { showToast } from "../../../toastService.js";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { IoClose } from "react-icons/io5";
import { ScaleLoader } from "react-spinners";
import { useSelector } from "react-redux";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    MenuItem,
    Select as MuiSelect
} from "@mui/material";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { MdEdit, MdSend } from "react-icons/md";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import numeral from "numeral";
import Big from "big.js";
import { formatStringToNumberV2 } from "../../../utils/genericFunctions.js";

const GlPeriodBalance = () => {
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [isEditBalanceDialogOpen, setIsEditBalanceDialogOpen] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [searchTerm, setSearchTerm] = useState("");
    const [entityCategories, setEntityCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [entityBalances, setEntityBalances] = useState([]);
    const [selectedEntityBalance, setSelectedEntityBalance] = useState(null);

    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        action_invoked: "",
    });
    const [periodDrcr, setPeriodDrcr] = useState("Dr");
    const [periodBalanceFc, setPeriodBalanceFc] = useState("");
    const [periodBalanceLc, setPeriodBalanceLc] = useState("");

    const fetEntityCategories = async () => {
        try {
            setIsLoading(true);
            const res = await newRequest.get("/allEntityCatg/findAll");
            setEntityCategories(res.data);
            setSelectedCategory(res.data[0]);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteCode") {

            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };


    const fetchClientsBySearch = async (inputValue, callback) => {
        try {
            if (inputValue?.length > 2) {
                const res = await newRequest.post("/allEntity/search", { search_input: inputValue, ent_status: "", ent_aent_code: selectedCategory?.aent_code });
                const options = res.data.map((entity) => ({
                    value: entity.ent_code,
                    label: (
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                            {entity.ent_name}
                            {entity.ent_status !== "Active" && (
                                <span style={{ color: "gray" }}> [{entity.ent_status}]</span>
                            )}
                        </div>
                    )
                }));

                callback(options);
            }
        } catch (error) {
            console.error("Error fetching entity types:", error);
            callback([]);
        }
    };

    const customNoOptionsMessage = (customMessage) => {
        return (
            <span
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <h1 className="sub-title">{customMessage}</h1>
            </span>
        );
    };

    useEffect(() => {
        fetEntityCategories();
    }, []);

    const fetchEntityBalances = async () => {
        try {
            setIsProcessing(true);
            const res = await newRequest.post("/entityBalance/getEntityGroupedBalances", {
                eb_ent_code: selectedEntity?.value,
                eb_cur_code: currentUser?.currency_code_xx
            });
            // console.log(`fetchEntityBalances  ${JSON.stringify(res.data, null, 2)}`);
            setEntityBalances(res.data);
            setSelectedEntityBalance(res.data[0]);
        } catch (error) {
            console.log(error);
        } finally {
            setIsProcessing(false);
        }
    }

    const updateEntityBalances = async () => {
        try {
            setIsProcessing(true);

            const res = await newRequest.put(`/entityBalance/upd/${selectedEntityBalance._id}`, {
                eb_balance_type: periodDrcr,
                eb_balance_fc: formatStringToNumberV2(periodBalanceFc),
                eb_balance_lc: periodBalanceLc
            });

            if (res.status === 200) {
                const updatedData = entityBalances.map(year => {
                    if (year._id === selectedEntityBalance.eb_year_code) {
                        return {
                            ...year,
                            periods: year.periods.map(period => {
                                if (period._id === selectedEntityBalance._id) {
                                    return {
                                        ...period,
                                        eb_balance_type: periodDrcr,
                                        eb_balance_fc: formatStringToNumberV2(periodBalanceFc),
                                        eb_balance_lc: periodBalanceLc
                                    };
                                }
                                return period;
                            })
                        };
                    }
                    return year;
                });
                setEntityBalances(updatedData);
                setIsProcessing(false);
                setIsEditBalanceDialogOpen(false);
                showToast(`${selectedEntityBalance.eb_year_code} closing balance for ${selectedEntityBalance?.eb_period_code} has been updated`,
                    "success"
                );
            } else {
                setIsProcessing(false);
                setIsEditBalanceDialogOpen(false);
                showToast(
                    `error updating the balance`,
                    "error"
                );

            }
        } catch (error) {
            console.log(error);
        }
    };


    const handleFcAmountBlur = (e) => {
        try {
            if (e.target.value) {
                const strippedValue = e.target.value.replace(/,/g, "");
                if (isNaN(strippedValue)) {
                    setNotifyDialogTitle("Error!");
                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                    setIsNotifyDialogOpen(true);
                    return;
                }

                const parsedValue = Big(strippedValue); // Use big.js to handle the value

                // Check if the parsed value is NaN
                if (!parsedValue.eq(parsedValue)) {
                    setPeriodBalanceFc("");
                } else {
                    setPeriodBalanceFc(formatNumber(parsedValue, 2));
                    const lcAmount = Number(parseFloat(parsedValue * 1).toFixed(4));
                    setPeriodBalanceLc(lcAmount);
                }
            }
        } catch (error) {
            console.log(error)
        }
    };

    const formatNumber = (value) => {
        if (isNaN(value)) return '';
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    };

    return (
        <div className="gl-period-balance">
            <div className="gl-period-balance-main-wrapper">
                <div className="gl-period-balance-center-wrapper">
                    <div className="center-navbar">
                        <div className="navbar-left"><h1 className="main-title">{selectedCategory?.aent_name}</h1></div>
                        <div className="navbar-right">
                            <div className="input-item-with-label" style={{ gap: "10px" }}>
                                {/* <label htmlFor="hd_ent_code">ENTITY</label> */}
                                <AsyncSelect
                                    id="entity"
                                    name="entity"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    height="40px"
                                    width="300px"
                                    value={selectedEntity}
                                    onChange={(selectedOption) => {
                                        try {
                                            setSelectedEntity(selectedOption);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    loadOptions={fetchClientsBySearch}
                                    isSearchable={true}
                                    placeholder="ENTITY"
                                    noOptionsMessage={() =>
                                        customNoOptionsMessage(
                                            "Type Minimum 3 Letter to Search"
                                        )
                                    } />
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    height={"38px"}
                                    borderRadiusType="right"
                                    disabled={!selectedEntity}
                                    endIcon={<MdSend />}
                                    onClick={async () => { await fetchEntityBalances() }}
                                >
                                    Get Balances
                                </CustomLoadingButton>
                            </div>
                        </div>
                    </div>
                    <div className="center-content">
                        <div className="periods-per-year">
                            {entityBalances?.map((ebal) => (
                                <ExpandableComponent
                                    key={ebal?._id}
                                    title={ebal?.eb_year_code}
                                    subtitle={null}
                                    bgColor="#fff"
                                    defaultExpanded={true}
                                >
                                    <div className="periods-list-wrapper">
                                        {ebal?.periods?.map((per) => {
                                            return (
                                                <div key={per?._id}
                                                    className={`${selectedEntityBalance?._id === per._id ? "single-period-item current" : "single-period-item"}`}
                                                    onClick={async () => {
                                                        try {
                                                            setSelectedEntityBalance(per);
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}>
                                                    <div className="single-period-header">
                                                        <span>{per?.eb_period_code}</span>
                                                        <CircularButton
                                                            currentTheme={currentTheme}
                                                            onClick={() => {
                                                                try {
                                                                    setSelectedEntityBalance(per);
                                                                    setPeriodDrcr(per?.eb_balance_type);
                                                                    setPeriodBalanceFc(per?.eb_balance_fc);
                                                                    setPeriodBalanceLc(per?.eb_balance_lc);
                                                                    setIsEditBalanceDialogOpen(true);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }} icon={<MdEdit />} width={"35px"} height={"35px"} />
                                                    </div>
                                                    <div className="single-period-balance">
                                                        <span>{per?.eb_balance_type}</span>
                                                        <span>{numeral(per?.eb_balance_fc || "0").format("0,0.00")}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </ExpandableComponent>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="gl-period-balance-right-wrapper">
                    <div className="search-input-wrapper" style={{ width: "90%" }}>
                        <FiSearch className="search-input-icon" />
                        <input
                            className="search-input"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm.length > 0 && (
                            <IoClose
                                onClick={async () => {
                                    try {

                                        setSearchTerm("");
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                                className="search-input-icon"
                            />
                        )}
                    </div>
                    <div className="categories-list">
                        {entityCategories
                            ?.filter(
                                (catg) =>
                                    catg.aent_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    catg.aent_name.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .map((catg) => (
                                <span
                                    key={catg?._id}
                                    className={`${selectedCategory?._id === catg?._id ? "single-category active" : "single-category"}`}
                                    onClick={async () => {
                                        try {
                                            setSelectedEntity(null);
                                            setEntityBalances(null);
                                            setPeriodBalanceLc(0);
                                            setPeriodBalanceFc(0);
                                            setSelectedCategory(catg);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                >
                                    <div className="title-row">
                                        <span className="cy-title">{catg?.aent_name}</span>
                                    </div>
                                </span>
                            ))}
                    </div>
                </div>
            </div>
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p>{objectToAction.action_text}</p>}
            />

            {isEditBalanceDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="sub-title">{`Edit ${selectedEntityBalance?.eb_year_code} ${selectedEntityBalance?.eb_period_code}`}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setPeriodBalanceFc(0);
                                        setPeriodBalanceLc(0);
                                        setIsEditBalanceDialogOpen(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label" style={{ gap: "10px" }}>
                                <label
                                    htmlFor="periodBalanceFc"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    BALANCE
                                </label>
                                <MuiSelect
                                    id="periodDrcr"
                                    name="periodDrcr"
                                    value={periodDrcr}
                                    onChange={(e) => setPeriodDrcr(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    sx={currentTheme === "dark" ? muiSelectStyles_dark().select : muiSelectStyles_light().select}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: currentTheme === "dark" ? muiSelectStyles_dark().menu.paper : muiSelectStyles_light().menu.paper
                                        }
                                    }}
                                >
                                    <MenuItem value="Dr" sx={{ height: '36px' }}>Debit</MenuItem>
                                    <MenuItem value="Cr" sx={{ height: '36px' }}>Credit</MenuItem>
                                </MuiSelect>
                                <input
                                    id="periodBalanceFc"
                                    name="periodBalanceFc"
                                    type="text"
                                    placeholder="0.00"
                                    value={periodBalanceFc}
                                    className="form-input-item"
                                    style={{ width: "170px", textAlign: "right" }}
                                    onChange={(e) => setPeriodBalanceFc(e.target.value)}
                                    onBlur={handleFcAmountBlur}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton onClick={updateEntityBalances}>Set</CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}

            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <ScaleLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
        </div>
    )
}

export default GlPeriodBalance;